import { IEmailTemplate } from '../types';

export const isSystemTemplate = (template: IEmailTemplate) => {
  return !template.workspaceId;
};
